<template>
  <v-dialog
    v-model="dialog"
    max-width="900"
    persistent
    scrollable
  >
    <v-card v-if="category">
      <v-card-title class="d-flex justify-space-between">
        <span>Configurar: {{ category.name }}</span>
        <v-btn
          icon
          @click="close"
        >
          <v-icon>{{ icons.mdiClose }}</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text
        class="pa-0"
        style="max-height: 70vh; overflow-y: auto;"
      >
        <v-tabs
          v-model="tab"
          background-color="grey lighten-4"
        >
          <v-tab>
            <v-icon
              left
              small
            >
              {{ icons.mdiText }}
            </v-icon>
            Detalhes
          </v-tab>
          <v-tab>
            <v-icon
              left
              small
            >
              {{ icons.mdiImageMultiple }}
            </v-icon>
            Imagens
          </v-tab>
          <v-tab>
            <v-icon
              left
              small
            >
              {{ icons.mdiStarBox }}
            </v-icon>
            Comodidades
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!-- Tab Detalhes -->
          <v-tab-item class="pa-4">
            <v-form ref="detailsForm">
              <v-textarea
                v-model="details.detailed_description"
                label="Descrição Detalhada"
                outlined
                rows="4"
                hint="Descreva o quarto de forma atrativa para os hóspedes"
                persistent-hint
                class="mb-4"
              ></v-textarea>

              <v-row>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    v-model="details.size"
                    label="Tamanho"
                    outlined
                    dense
                    placeholder="Ex: 25 m²"
                    :prepend-inner-icon="icons.mdiRulerSquare"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    v-model="details.bed_type"
                    label="Tipo de Cama"
                    outlined
                    dense
                    placeholder="Ex: 1 cama de casal"
                    :prepend-inner-icon="icons.mdiBed"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    v-model.number="details.max_adults"
                    label="Qtd Adultos"
                    outlined
                    dense
                    type="number"
                    min="0"
                    :prepend-inner-icon="icons.mdiAccount"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    v-model.number="details.max_children"
                    label="Qtd Crianças"
                    outlined
                    dense
                    type="number"
                    min="0"
                    :prepend-inner-icon="icons.mdiAccountChild"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>

            <div class="d-flex justify-end mt-4">
              <v-btn
                color="primary"
                :loading="savingDetails"
                @click="saveDetails"
              >
                Salvar Detalhes
              </v-btn>
            </div>
          </v-tab-item>

          <!-- Tab Imagens -->
          <v-tab-item class="pa-4">
            <v-alert
              type="info"
              text
              dense
              class="mb-4"
            >
              Arraste as imagens para reordenar. A primeira imagem será usada como capa.
              Formatos aceitos: JPG, PNG, WebP. Tamanho máximo: 5MB.
            </v-alert>

            <!-- Upload de imagens -->
            <v-card
              outlined
              class="image-upload"
            >
              <v-card-text class="pa-4">
                <div class="d-flex align-center mb-3">
                  <div class="image-upload__icon">
                    <v-icon color="primary">
                      {{ icons.mdiCamera }}
                    </v-icon>
                  </div>
                  <div>
                    <div class="text-subtitle-2">
                      Enviar imagens
                    </div>
                    <div class="text-caption grey--text">
                      Arraste aqui ou clique para selecionar arquivos
                    </div>
                  </div>
                </div>

                <v-file-input
                  v-model="newImages"
                  label="Adicionar imagens"
                  outlined
                  dense
                  multiple
                  chips
                  counter
                  accept="image/jpeg,image/png,image/webp"
                  :prepend-inner-icon="icons.mdiImageMultiple"
                  show-size
                  class="image-upload__input"
                  :loading="uploadingImages"
                  :disabled="uploadingImages"
                  @change="uploadImages"
                ></v-file-input>
              </v-card-text>
            </v-card>

            <!-- Galeria de imagens -->
            <div class="images-grid mt-4">
              <draggable
                v-model="images"
                class="d-flex flex-wrap"
                ghost-class="ghost"
                @end="onImageReorder"
              >
                <div
                  v-for="(image, index) in images"
                  :key="image.id"
                  class="image-item ma-2"
                >
                  <v-card
                    outlined
                    class="image-card"
                  >
                    <v-img
                      :src="image.url"
                      aspect-ratio="1.5"
                      height="120"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>

                    <v-card-actions class="pa-1 justify-center">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            x-small
                            :color="image.is_cover ? 'warning' : 'grey'"
                            v-on="on"
                            @click="setCover(image)"
                          >
                            <v-icon x-small>
                              {{ icons.mdiStar }}
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>{{ image.is_cover ? 'Imagem de capa' : 'Definir como capa' }}</span>
                      </v-tooltip>

                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            icon
                            x-small
                            color="error"
                            v-on="on"
                            @click="deleteImage(image)"
                          >
                            <v-icon x-small>
                              {{ icons.mdiDelete }}
                            </v-icon>
                          </v-btn>
                        </template>
                        <span>Remover imagem</span>
                      </v-tooltip>
                    </v-card-actions>

                    <v-chip
                      v-if="image.is_cover"
                      x-small
                      color="warning"
                      class="cover-badge"
                    >
                      Capa
                    </v-chip>

                    <div class="order-badge">
                      {{ index + 1 }}
                    </div>
                  </v-card>
                </div>
              </draggable>

              <div
                v-if="images.length === 0"
                class="text-center py-8 grey--text"
              >
                <v-icon
                  size="48"
                  color="grey lighten-1"
                >
                  {{ icons.mdiImageOff }}
                </v-icon>
                <p class="mt-2">
                  Nenhuma imagem cadastrada
                </p>
              </div>
            </div>
          </v-tab-item>

          <!-- Tab Comodidades -->
          <v-tab-item class="pa-4">
            <v-alert
              type="info"
              text
              dense
              class="mb-4"
            >
              Selecione as comodidades disponíveis nesta categoria de quarto.
            </v-alert>

            <div
              v-for="(groupName, groupKey) in groups"
              :key="groupKey"
              class="mb-4"
            >
              <div class="text-subtitle-1 font-weight-medium mb-2">
                <v-icon
                  small
                  left
                >
                  {{ getGroupIcon(groupKey) }}
                </v-icon>
                {{ groupName }}
              </div>

              <v-chip-group
                v-model="selectedAmenities"
                column
                multiple
              >
                <v-chip
                  v-for="amenity in getAmenitiesByGroup(groupKey)"
                  :key="amenity.id"
                  :value="amenity.id"
                  filter
                  outlined
                >
                  <v-icon
                    v-if="resolveMdiIcon(amenity.icon)"
                    left
                    small
                  >
                    {{ resolveMdiIcon(amenity.icon) }}
                  </v-icon>
                  {{ amenity.name }}
                </v-chip>
              </v-chip-group>
            </div>

            <div class="d-flex justify-end mt-4">
              <v-btn
                color="primary"
                :loading="savingAmenities"
                @click="saveAmenities"
              >
                Salvar Comodidades
              </v-btn>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import * as mdiIcons from '@mdi/js'
import {
  mdiAccountGroup,
  mdiBed,
  mdiCamera,
  mdiClose,
  mdiDelete,
  mdiEye,
  mdiHome,
  mdiImageMultiple,
  mdiImageOff,
  mdiRulerSquare,
  mdiShieldCheck,
  mdiShower,
  mdiStar,
  mdiStarBox,
  mdiText,
  mdiAccount,
  mdiAccountChild,
} from '@mdi/js'
import draggable from 'vuedraggable'

export default {
  name: 'CategoryDetailsModal',

  components: {
    draggable,
  },

  props: {
    value: Boolean,
    category: Object,
    amenities: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Object,
      default: () => ({}),
    },
    canEdit: Boolean,
  },

  data: () => ({
    tab: 0,
    loading: false,

    details: {
      detailed_description: '',
      size: '',
      bed_type: '',
      max_adults: null,
      max_children: null,
    },
    savingDetails: false,

    images: [],
    newImages: [],
    uploadingImages: false,

    selectedAmenities: [],
    savingAmenities: false,

    groupIcons: {
      bathroom: mdiShower,
      view: mdiEye,
      room: mdiBed,
      general: mdiHome,
      policy: mdiShieldCheck,
    },
    icons: {
      mdiAccount,
      mdiAccountChild,
      mdiAccountGroup,
      mdiBed,
      mdiCamera,
      mdiClose,
      mdiDelete,
      mdiImageMultiple,
      mdiImageOff,
      mdiRulerSquare,
      mdiStar,
      mdiStarBox,
      mdiText,
    },
  }),

  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },

  watch: {
    value(val) {
      if (val && this.category) {
        this.loadCategoryDetails()
      }
    },
  },

  methods: {
    resolveMdiIcon(name) {
      if (!name) return null
      if (name.startsWith('mdi')) {
        if (!name.includes('-')) return mdiIcons[name] || null
        const key = `mdi${name
          .replace(/^mdi-/, '')
          .split('-')
          .map(part => part.charAt(0).toUpperCase() + part.slice(1))
          .join('')}`

        return mdiIcons[key] || null
      }

      return null
    },
    async loadCategoryDetails() {
      this.loading = true
      try {
        const response = await this.$http.get(
          `system/booking-engine-config/room-categories/${this.category.id}/details`,
        )
        const { data } = response.data

        this.details = {
          detailed_description: data.detailed_description || '',
          size: data.size || '',
          bed_type: data.bed_type || '',
          max_adults: data.max_adults ?? null,
          max_children: data.max_children ?? null,
        }
        if (this.details.max_adults === null && this.details.max_children === null && data.max_guests) {
          this.details.max_adults = data.max_guests
          this.details.max_children = 0
        }

        this.images = data.images || []
        this.selectedAmenities = data.amenities || []
      } catch (error) {
        console.error('Erro ao carregar detalhes:', error)
        this.$toast.error('Erro ao carregar detalhes da categoria')
      } finally {
        this.loading = false
      }
    },

    close() {
      this.dialog = false
      this.tab = 0
      this.$emit('saved')
    },

    getGroupIcon(group) {
      return this.groupIcons[group] || this.icons.mdiStar
    },

    getAmenitiesByGroup(group) {
      return this.amenities.filter(a => a.group === group && a.active)
    },

    // Detalhes
    async saveDetails() {
      this.savingDetails = true
      try {
        await this.$http.put(
          `system/booking-engine-config/room-categories/${this.category.id}/details`,
          this.details,
        )
        this.$toast.success('Detalhes salvos com sucesso')
      } catch (error) {
        console.error('Erro ao salvar detalhes:', error)
        this.$toast.error('Erro ao salvar detalhes')
      } finally {
        this.savingDetails = false
      }
    },

    // Imagens
    async uploadImages() {
      if (!this.newImages || this.newImages.length === 0) return

      this.uploadingImages = true
      try {
        const formData = new FormData()
        this.newImages.forEach(file => {
          formData.append('images[]', file)
        })

        const response = await this.$http.post(
          `system/booking-engine-config/room-categories/${this.category.id}/images`,
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        )

        if (response.data.success) {
          this.images.push(...response.data.data)
          this.$toast.success('Imagens enviadas com sucesso')
        }
      } catch (error) {
        console.error('Erro ao enviar imagens:', error)
        this.$toast.error('Erro ao enviar imagens')
      } finally {
        this.uploadingImages = false
        this.newImages = []
      }
    },

    async deleteImage(image) {
      const confirmed = await this.$swal.fire({
        title: 'Confirmar exclusão',
        text: 'Deseja remover esta imagem?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover',
        cancelButtonText: 'Cancelar',
      })

      if (!confirmed.isConfirmed) return

      try {
        await this.$http.delete(
          `system/booking-engine-config/room-categories/${this.category.id}/images/${image.id}`,
        )
        this.images = this.images.filter(img => img.id !== image.id)
        this.$toast.success('Imagem removida com sucesso')
      } catch (error) {
        console.error('Erro ao remover imagem:', error)
        this.$toast.error('Erro ao remover imagem')
      }
    },

    async setCover(image) {
      if (image.is_cover) return

      try {
        await this.$http.put(
          `system/booking-engine-config/room-categories/${this.category.id}/images/${image.id}/cover`,
        )
        this.images.forEach(img => {
          img.is_cover = img.id === image.id
        })
        this.$toast.success('Imagem de capa atualizada')
      } catch (error) {
        console.error('Erro ao definir capa:', error)
        this.$toast.error('Erro ao definir imagem como capa')
      }
    },

    async onImageReorder() {
      try {
        const imagesOrder = this.images.map((img, index) => ({
          id: img.id,
          display_order: index,
        }))

        await this.$http.put(
          `system/booking-engine-config/room-categories/${this.category.id}/images/order`,
          { images: imagesOrder },
        )
      } catch (error) {
        console.error('Erro ao reordenar imagens:', error)
        this.$toast.error('Erro ao reordenar imagens')
      }
    },

    // Comodidades
    async saveAmenities() {
      this.savingAmenities = true
      try {
        await this.$http.post(
          `system/booking-engine-config/room-categories/${this.category.id}/amenities`,
          { amenity_ids: this.selectedAmenities },
        )
        this.$toast.success('Comodidades salvas com sucesso')
      } catch (error) {
        console.error('Erro ao salvar comodidades:', error)
        this.$toast.error('Erro ao salvar comodidades')
      } finally {
        this.savingAmenities = false
      }
    },
  },
}
</script>

<style scoped>
.images-grid {
  min-height: 150px;
}

.image-upload {
  border: 1px dashed rgba(0, 0, 0, 0.2);
  background: #fafafa;
}

.image-upload__icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: rgba(22, 177, 255, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
}

.image-upload__input ::v-deep .v-input__control {
  background: #fff;
  border-radius: 8px;
}

.image-item {
  position: relative;
  width: 150px;
}

.image-card {
  position: relative;
  cursor: grab;
}

.image-card:active {
  cursor: grabbing;
}

.cover-badge {
  position: absolute;
  top: 4px;
  left: 4px;
}

.order-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: bold;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
